/**
 *
 * Asynchronously loads the component for VolunteerGroups
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
